export const routes = {
  home: "/",
  signin: {
    root: "/signin",
  },
  orders: {
    root: "/orders",
  },
  ordersStatistic: {
    root: "/ordersStatistic",
  },
  history: {
    root: "/history",
  },
  drivers: {
    root: "/drivers",
  },
  clients: {
    root: "/clients",
  },
  tariffs: {
    root: "/tariffs",
  },
  discount: {
    root: "/discount",
  },
  newsletters: {
    root: "/newsletters",
  },
};
